import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import type { UpsertProductInput } from '@nokowazzi/types';
import { toast } from '@nokowazzi/ui';
import { PageHeader } from '../components/PageHeader';
import { ProductForm } from '../features/products/ProductForm';
import { ApiError, apiFetch } from '../lib/api';

export const Route = createFileRoute('/_admin/products/new')({
  component: ProductNewScreen,
});

function ProductNewScreen() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (input: UpsertProductInput) =>
      apiFetch<unknown>('/v1/admin/products', { method: 'POST', json: input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['admin', 'products'] });
      toast.show({ type: 'success', message: '상품이 등록되었습니다' });
      await navigate({ to: '/products' });
    },
    onError: (error) => {
      toast.show({
        type: 'error',
        message: error instanceof ApiError ? error.message : '상품 등록에 실패했습니다',
      });
    },
  });

  return (
    <>
      <PageHeader title="상품 등록" />
      <ProductForm
        submitting={createMutation.isPending}
        onSubmit={(input) => createMutation.mutate(input)}
      />
    </>
  );
}
